import { render, staticRenderFns } from "./RaPeriods.vue?vue&type=template&id=191275da"
import script from "./RaPeriods.vue?vue&type=script&lang=js"
export * from "./RaPeriods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports